export default "__VITE_ASSET__C8V8_a1q__"